/**
 * SearchContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search container.
 */
const SearchContainer = styled.div<React.CSSProperties>`
  position: absolute;
  top: ${66 * Screen.widthRatio}px;
`;

export default SearchContainer;
